// Typelizer digest 8df1dee22a71973809662bdc1dec5c90
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /operation */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/operation', {}, options),
    method: 'get',
  }),

  /** PATCH /operation */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/operation', {}, options),
    method: 'patch',
  }),

  /** DELETE /operation */
  destroy: (options?: RouteOptions): RouteDefinition<'delete'> => ({
    url: buildUrl('/operation', {}, options),
    method: 'delete',
  }),

  /** POST /operations */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/operations', {}, options),
    method: 'post',
  }),
}
